import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const Icon3x4 = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M7.758 11.032l1.704-2.256V7.6h-5.16v1.296h3.516l-1.812 2.388.552.828h.312c.948 0 1.56.504 1.56 1.344 0 .84-.612 1.356-1.56 1.356-.84 0-1.404-.372-1.644-1.08l-1.176.684c.468 1.176 1.584 1.74 2.82 1.74 1.548 0 2.94-.936 2.94-2.7 0-1.308-.9-2.148-2.052-2.424zm4.009.612a.899.899 0 1 0 0-1.8c-.505 0-.9.396-.9.9 0 .492.395.9.9.9zm0 4.5a.899.899 0 1 0 0-1.8c-.505 0-.9.396-.9.9 0 .492.395.9.9.9zm8.278-2.94h-.96V11.02h-1.392v2.184h-2.628L17.957 7.6h-1.5l-2.892 5.604v1.284h4.128V16h1.392v-1.512h.96v-1.284z" }),
});

export { Icon3x4 };
